// src/components/MissionSection.jsx
import React from "react";
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  Chip,
  Typography,
} from "@mui/material";
import SectionHeader from "./SectionHeader";

const steps = [
  {
    title: "Integrity at the edge",
    text: "We start at the device: binding meters, sites and assets to cryptographic identities. Each reading is signed and tamper-evident from the moment it’s created.",
  },
  {
    title: "Deterministic energy-to-carbon mapping",
    text: "A transparent rules engine translates energy data into carbon tokens using configurable emissions factors, baselines and methodologies suitable for your jurisdiction or program.",
  },
  {
    title: "Certificates you can compute on",
    text: "Carbon Credit Certificates are minted as digital assets with rich metadata, enabling real-time portfolio views, risk analysis and automated retirement flows across multiple chains and registries.",
  },
  {
    title: "Climate decisions on live data",
    text: "A forecasting and analytics layer turns raw measurements into insight: abatement curves, scenario modelling and compliance alerts backed by auditable data lineage.",
  },
];

const MissionSection = () => (
  <Box
    id="mission"
    sx={{
      py: { xs: 6, md: 8 },
      bgcolor: "grey.100",
    }}
  >
    <Container maxWidth="lg">
      <Grid container spacing={4}>
        <Grid item xs={12} md={5}>

          <SectionHeader

            title="Our Mission"
            subtitle="Make every unit of renewable energy and every carbon credit provable, programmable and trustworthy - from device to regulator."
          />
          <Typography>
            We believe carbon accounting should be as rigorous as financial
            accounting. Our mission is to give organisations a computing fabric
            where climate data is not just recorded, but mathematically
            guaranteed and easily verified.
          </Typography>
        </Grid>
        <Grid item xs={12} md={7}>
          <Card 
            className="glass-card glow"
            sx={{ borderRadius: 3, boxShadow: 1 }}>
            <CardContent sx={{ p: 3 }}>
              <Chip
                label="How we deliver"
                sx={{
                  mb: 2,
                  borderRadius: 999,
                  fontSize: 11,
                  letterSpacing: "0.12em",
                  textTransform: "uppercase",
                }}
              />
              {steps.map((step, idx) => (
                <Box key={step.title} sx={{ display: "flex", mb: 2.5 }}>
                  <Box
                    sx={{
                      minWidth: 34,
                      height: 34,
                      borderRadius: "50%",
                      bgcolor: "#111827",
                      color: "#e5e7eb",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 14,
                      fontWeight: 500,
                      mr: 2,
                    }}
                  >
                    {idx + 1}
                  </Box>
                  <Box>
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 500, mb: 0.5 }}
                    >
                      {step.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "text.secondary" }}
                    >
                      {step.text}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  </Box>
);

export default MissionSection;
